import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EastIcon from "@mui/icons-material/East";
import { useLanguage } from "../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { useLangCountry } from "../../utils/getLangCountry";

const features = ["Instant Setup", "24/7 Support", "Deep Liquidity"];

const NewWealth = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { language, toggleLanguage, translations } = useLanguage();
  const { lang } = useLangCountry();
  return (
    <Box sx={{ padding: { xs: " 10px",md: "0rem 4.2rem" } }}>
      <Box
        sx={{
   
          paddingTop: 0.1,
          borderRadius: "20px",
          minHeight: "420px",
        }}
      >
        <Box
          sx={{
            backgroundImage: "url('https://res.cloudinary.com/dk24unkwu/image/upload/v1753695253/wealthback_q2mozc.png')", // ← replace with your image path
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            py: { xs: 2, md: 4 },
            textAlign: "center",
            px: 2,
            borderRadius: "20px",
            color: "#000",
            minHeight: "450px",
            marginBottom: "30px",
            border: "0.2px solid rgba(36, 148, 201, 0.5)",
          }}
        >
          {/* Logo */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: 2,
                // boxShadow: 3,
                overflow: "hidden",
              }}
            >
              <img
                src="/Images/ShadowLogo.png" // ← replace with your logo path
                alt="Logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
          </Box>

          {/* Heading */}
          <Typography
            variant={isMobile ? "h5" : "h2"}
            fontWeight={700}
            sx={{
              mb: 3,
              lineHeight: "70px",
              fontSize: { xs: "23px", sm: "45px", md: "55px", lg: "60px" },
            }}
          >
            {translations[language]?.newWealthTitle}
            <br /> {translations[language]?.newWealthTitle2}
          </Typography>

          {/* Features */}
          <Typography
            variant="caption"
            color="rgba(0, 0, 0, 0.7)"
            mt={3}
            display="block"
            textAlign="center"
            style={{ fontSize: "15px", fontWeight: "500" }}
          >
            {translations[language]?.newWealthDes}
            <br /> {translations[language]?.newWealthDes2}
          </Typography>

          {/* CTA Button */}
          <Button
            disableRipple
            onClick={() => {
              const userCountry = localStorage.getItem('userCountry');
              const currentPath = window.location.pathname;
              const isInCountryPath = currentPath.includes(`/${lang}/lb`);
              
              if (userCountry === "lb" || isInCountryPath) {
                navigate(`/${lang}/lb/partner`);
              } else {
                navigate(`/${lang}/partner`);
              }
            }}
            variant="contained"
            sx={{
              backgroundColor: "rgba(25, 171, 226, 1)",
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 400,
              px: 4,
              py: 1.5,
              marginTop: "22px",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "rgba(25, 171, 226, 1)",
                boxShadow: "none",
              },
              "&:active": {
                boxShadow: "none", // 🛑 no shadow on click
              },
            }}
          >
            {translations[language]?.weathButton}&nbsp;
            <EastIcon />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NewWealth;
